import React from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import './Footer.scss'
import { Logo } from '../../components'
import { profile, sections } from '../../data/portfolio'
import { goToSection } from '../../utils/scroll'

const Footer = () => {
  const year = new Date().getFullYear();
  const location = useLocation();
  const navigate = useNavigate();

  const onSectionClick = (event, id) => {
    event.preventDefault();
    goToSection(id, location, navigate);
  };

  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div className="site-footer__brand">
          <Link to="/" className="site-footer__logo"><Logo size="small" /><span className="site-footer__name">Paradzai Gwira</span></Link>
          <p>AI Software Engineer building intelligent automation, real-time data systems and dependable production software.</p>
          <div className="site-footer__social">
            <a href={profile.github} target="_blank" rel="noreferrer" aria-label="GitHub"><i className="fa-brands fa-github" /></a>
            <a href={profile.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn"><i className="fa-brands fa-linkedin-in" /></a>
            <a href={profile.whatsapp} target="_blank" rel="noreferrer" aria-label="WhatsApp"><i className="fa-brands fa-whatsapp" /></a>
            <a href={`mailto:${profile.email}`} aria-label="Email"><i className="fas fa-envelope" /></a>
          </div>
        </div>

        <nav className="site-footer__col" aria-label="Footer">
          <h5>Explore</h5>
          {sections.filter((section) => section.id !== 'home').map((section) => (
            <a key={section.id} href={`/#${section.id}`} onClick={(event) => onSectionClick(event, section.id)}>{section.label}</a>
          ))}
          <Link to="/services">Services</Link>
        </nav>

        <div className="site-footer__col">
          <h5>Contact</h5>
          <a href={`mailto:${profile.email}`}>{profile.email}</a>
          <a href="tel:+263715336984">{profile.phone}</a>
          <span>{profile.location}</span>
          <Link to={profile.cvPage}>View CV</Link>
          <a href={profile.resume} download="Paradzai-Gwira-AI-Software-Engineer-CV.pdf">Download CV (PDF) ↓</a>
        </div>
      </div>

      <div className="site-footer__bottom">
        <span>© {year} Paradzai Gwira. All rights reserved.</span>
        <span className="site-footer__status"><span className="site-footer__dot" /> All systems operational</span>
      </div>
    </footer>
  )
}

export default Footer
